import { render, staticRenderFns } from "./examinetopic-form-type.vue?vue&type=template&id=271ce1ff&"
import script from "./examinetopic-form-type.vue?vue&type=script&lang=js&"
export * from "./examinetopic-form-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports